import { connect } from 'react-redux';
import PanelGroup from './panelGroup';
import { closeAllPanels } from '../../../../shared/actions/sidebar';

const mapStateToProps = state => ({ updatedPosition: state.sidebar.updatedPosition });

const mapDispatchToProps = dispatch => ({
  closeAllPanels: () => dispatch(closeAllPanels()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelGroup);
